import React, { useEffect } from 'react';
import { SEO } from '../components/SEO';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
export function About() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="min-h-screen bg-[#FAFAFA] font-sans selection:bg-kitty-yellow-200 selection:text-kitty-dark" data-id="element-394" data-mp="29lgguz85bwno">
      <SEO title="About | KittyPot" description="The story behind KittyPot, a shared expense tracker that helps groups split costs fairly and keep track of who owes what." ogTitle="About KittyPot" ogDescription="Why we built KittyPot, and what it does for your group." path="/about" data-id="element-395" data-mp="2egm35z5gndca" />
      <Navbar data-id="element-396" data-mp="2x8y4qjoaiald" />
      <main className="pt-32 pb-24" data-id="element-397" data-mp="2x8ettmx24mgu">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-398" data-mp="2x7d88oif0hkv">
          <h1 className="text-4xl font-black text-kitty-dark mb-6" data-id="element-399" data-mp="1gtwrexkyhmd8">
            About KittyPot
          </h1>
          <p className="text-2xl font-extrabold text-kitty-dark mb-8 leading-snug" data-id="element-400" data-mp="1luu9zb9voif9">
            Money between friends shouldn't be awkward.
          </p>
          <div className="prose prose-gray max-w-none text-gray-600 space-y-6" data-id="element-401" data-mp="1pip1hn8n0v60">
            <p data-id="element-402" data-mp="1pl1q2j8wi3s1">
              KittyPot was built to make shared spending easier. Whether it's a
              weekend away, a night out or everyday costs, KittyPot keeps track
              of who paid and who owes what so the group doesn't have to.
            </p>
            <p data-id="element-403" data-mp="2dfct283wtnvf">
              It started with a simple question: how do groups keep things fair
              when one person pays and everyone else needs to settle up?
            </p>
            <p data-id="element-404" data-mp="2m7wkanhvgq68">
              The idea was sparked during a family conversation about organising
              a kitty for a bike tour. With contactless replacing cash, keeping
              track of shared spending had quietly become harder, not easier.
            </p>
            <p data-id="element-405" data-mp="2r8awmhqiama2">
              So we built KittyPot around the bit that actually causes friction:
              the record. You create a kitty, everyone adds what they spend, and
              KittyPot keeps a clear, shared view of who owes what. When it is
              time to settle, people pay each other directly, KittyPot does not
              hold or move anyone's money.
            </p>
            <p data-id="element-406" data-mp="22lrjwhb2tmp2">
              It is deliberately simple. Splitting costs, tracking shared
              spending and knowing where you stand should take seconds, not a
              spreadsheet and a group chat.
            </p>
            <p data-id="element-407" data-mp="2cj5z6dl9k5fs">
              We are a small UK team, and we are building KittyPot with the
              people who use it. If something is missing or awkward, we would
              genuinely like to hear about it.
            </p>
            <p className="font-bold text-kitty-dark mt-8" data-id="element-408" data-mp="2lk44r0bcol0h">
              Built in Cardiff, Wales.
            </p>
            <p className="font-medium" data-id="element-409" data-mp="ma5rieo3l1q9">Benjamin Elliott, Founder</p>
          </div>
        </div>
      </main>
      <Footer data-id="element-410" data-mp="r8pcabqyg7h1" />
    </div>;
}